// Fase 6A: Definición central de planes de suscripción
// ⚠️ No integrado aún con Google Play Billing

export const PLANS = {
  FREE: 'free',
  PREMIUM_PERSONAL: 'premium_personal',
  PREMIUM_PRO: 'premium_pro',
};

/**
 * Devuelve el objeto de permisos (feature flags) para un plan dado.
 * Todos los flags son booleanos. Por defecto se asume FREE si el plan es desconocido.
 */
export function getPermissionsForPlan(plan) {
  switch (plan) {
    case PLANS.PREMIUM_PRO:
      return {
        canUseMultipleProfiles:      true,
        canUseUnlimitedClients:      true,
        canUseQuickWhatsApp:         true,
        canUseQuickGoogleMaps:       true,
        canUseInformativeNotes:      true,
        canUseQuickWeb:              true,
        canUseQuickImage:            true,
        canUseCompanyName:           true,
        canUseRouteStates:           true,
        canUseTeamAlerts:            true,
        canUseSharedRouteStates:     true,
        canUseProfessionalWhatsApp:  true,
      };

    case PLANS.PREMIUM_PERSONAL:
      return {
        canUseMultipleProfiles:      false,
        canUseUnlimitedClients:      true,
        canUseQuickWhatsApp:         true,
        canUseQuickGoogleMaps:       true,
        canUseInformativeNotes:      true,
        canUseQuickWeb:              true,
        canUseQuickImage:            true,
        canUseCompanyName:           true,
        canUseRouteStates:           true,
        canUseTeamAlerts:            false,
        canUseSharedRouteStates:     false,
        canUseProfessionalWhatsApp:  false,
      };

    case PLANS.FREE:
    default:
      return {
        canUseMultipleProfiles:      false,
        canUseUnlimitedClients:      false,
        canUseQuickWhatsApp:         false,
        canUseQuickGoogleMaps:       true,
        canUseInformativeNotes:      false,
        canUseQuickWeb:              false,
        canUseQuickImage:            false,
        canUseCompanyName:           false,
        canUseRouteStates:           false,
        canUseTeamAlerts:            false,
        canUseSharedRouteStates:     false,
        canUseProfessionalWhatsApp:  false,
      };
  }
}
